import css from 'styled-jsx/css';

export default css`#framework-sider-bar-container {
  position: fixed;
  top: 64px;
  right: 0;
  bottom: 0;
  padding-top: 40px;
  box-shadow: 0px 0px 10px 0px rgba(7, 19, 43, 0.1);
  background-color: #fff;
  z-index: 100;

  .position-box {
    position: relative;
    width: 46px;
    height: 100%;
    transition: .2s width;
  }

  p{
    margin: 0;
  }

  & a,
  & a:focus,
  & a:hover {
    text-decoration: none;
  }

  .siderbar-bottom-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 64px;
    :global(svg) {
      width: 36px;
      height: 18px;
    }
    :global(.item-icon-box) {
      height: 18px;
    }
    :global(.item-title-box) {
      padding-top: 4px;
    }
  }

  #fix-sider-bar-download-app-modal {
    position: fixed;
    display: none;
    top: 0;
    z-index: 1000;

    img {
      width: 378px;
    }
  }

  #sider-bar-applylist,
  #sider-bar-favorite,
  #sider-bar-download-app {
    :global(svg) {
      width: 30px;
      height: 30px;
    }
    :global(.item-title-box){
      color: #fff;
      transition: .2s all;
      height: 25px; // 限制高度，避免文字高度变化引起的跳动
      overflow: hidden;
    }
  }

  #framework-sider-bar-feedback{
    :global(.item-title-box){
      padding: 0 11px;
      height: 22px; // 限制高度，避免文字高度变化引起的跳动
      transition: .2s all;
    }
  }

  // 鼠标悬浮时的样式
  &:hover{
    .position-box{
      width: 60px;
    }

    #sider-bar-applylist,
    #sider-bar-favorite,
    #sider-bar-download-app {
      :global(.item-title-box){
        color: #333;
        transition: all linear .2s;
      }
    }
    
    #framework-sider-bar-feedback{
      :global(.item-title-box){
        padding: 0;
        transition: all linear .2s;
      }
    }
  }
}
`